import { Link } from "react-router-dom";
import { PageTitle } from "../components/site/PageTitle";
import { useSite } from "../context/SiteContext";
import { imgUrl } from "../lib/api";

const PriceTable = ({ t }) => (
  <div className="panel overflow-hidden border-[#2563EB]/30" data-testid={`pricing-table-${t.id}`}>
    <div className="border-b border-white/10 bg-gradient-to-r from-[#3a0a0d] to-[#0b1a4a] px-6 py-5">
      <h3 className="red-title text-2xl">{t.title}</h3>
      <p className="text-sm text-slate-300">{t.subtitle}</p>
    </div>
    <table className="w-full text-left">
      <thead><tr className="font-mono-label text-xs uppercase tracking-widest text-slate-400"><th className="px-6 py-3">Quantity</th><th className="px-6 py-3 text-right">{t.unit_label}</th></tr></thead>
      <tbody>
        {t.tiers.map((r, i) => (
          <tr key={i} className="border-t border-white/5 transition-colors hover:bg-white/5">
            <td className="px-6 py-3 font-display text-lg font-bold">{r.qty}</td>
            <td className="px-6 py-3 text-right font-display text-xl font-black text-[#E5202A]">${r.price}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default function Pricing() {
  const { settings: s = {}, pricing = [] } = useSite();
  return (
    <div className="pb-20">
      <PageTitle badge="ASAP & Co." title="Pricing" subtitle={s.pricing_intro} testId="pricing-title" flash />
      <div className="mx-auto max-w-5xl space-y-8 px-6">
        <div className="panel border-[#E5202A]/70 bg-gradient-to-r from-[#3a0a0d] via-[#0E1018] to-[#0b1a4a] p-6 text-center" data-testid="pricing-bulk-banner">
          <h2 className="red-title text-2xl md:text-3xl">{s.bulk_title}</h2>
          <p className="mt-1 text-lg font-bold">{s.bulk_text}</p>
        </div>
        <div className="panel p-6 text-center">
          <h2 className="red-title text-2xl">Included With Listed Pricing</h2>
          <p className="mt-2 text-sm text-slate-300">{s.pricing_included}</p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {pricing.map((t) => <PriceTable key={t.id} t={t} />)}
        </div>
        <div className="panel grid items-center gap-6 p-6 md:grid-cols-2" data-testid="pricing-gang-sheets">
          <div>
            <h2 className="red-title text-3xl">Gang Sheets</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-300">{s.gang_sheet_text}</p>
            {s.gang_enabled !== false && <Link to="/gang-sheet" className="btn-red mt-5" data-testid="pricing-gang-builder-button">Build Your Gang Sheet</Link>}
          </div>
          {s.gang_sheet_image && <img src={imgUrl(s.gang_sheet_image)} alt="Gang sheet price list" className="w-full rounded-xl border border-white/10" />}
        </div>
        <div className="panel p-6">
          <h3 className="font-display text-2xl font-bold uppercase">Pricing Notes</h3>
          <ul className="mt-3 grid gap-2 text-sm text-slate-300 sm:grid-cols-2">
            {(s.pricing_notes || []).map((n) => <li key={n} className="flex gap-2"><span className="text-[#E5202A]">★</span>{n}</li>)}
          </ul>
        </div>
        <div className="text-center">
          <h3 className="font-display text-3xl font-black uppercase">Ready To Order?</h3>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-slate-400">Start a custom order, add your item details, upload artwork at checkout, and we'll review your request before sending an invoice or payment link.</p>
          <Link to="/order" className="btn-red mt-6" data-testid="pricing-start-order-button">Start Custom Order</Link>
        </div>
      </div>
    </div>
  );
}
